import React, { useState, useEffect, useRef } from 'react';
import '../style/HamburgerMenu.css';
import { useHamburgerMenu } from '../contexts/HamburgerMenuContext';

const HamburgerMenu = () => {
  const menuRef = useRef(null);  // Add a ref for the menu
  const { isHamburgerOpen, setIsHamburgerOpen } = useHamburgerMenu();

  const toggleMenu = () => {
    if (isHamburgerOpen){
      setIsHamburgerOpen(false);
    }
    else{
      setIsHamburgerOpen(true);
    }
  }

  return (
    <div className="header">
      <div className="hamburger-icon" onClick={() => toggleMenu()}>
        <div className={`bar ${isHamburgerOpen ? 'open' : ''}`}></div>
        <div className={`bar ${isHamburgerOpen ? 'open' : ''}`}></div>
        <div className={`bar ${isHamburgerOpen ? 'open' : ''}`}></div>
      </div>
    </div>
  );
};

export default HamburgerMenu;
